module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gbR9A"))).then(() => parcelRequire('9Lwss'));